export default __webpack_public_path__ + "static/media/Silver Oaks_1.35181a15.jpg";